import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import InputField from "../../forms/input-field";
import SelectField from "../../forms/select-field";
import TextAreaField from "../../forms/textarea-field";
import { useDispatch } from "react-redux";
import {
  pincodeListAction,
  stateListAction,
} from "../../../redux/actions/general-action";
import AddButton, { DraftButton } from "../../buttons/button";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {
  storeDetailsGetAction,
  storeDetailsUpdateAction,
} from "../../../redux/actions/settings-action";
import successToast from "../../helper-components/success-toast";
import ImageField from "../../forms/images-field";
import LoadingSpinner from "../../helper-components/loading-spinner";
import {
  formatString,
  handleShowErrorToast,
} from "../../helper-components/helper-function";

const StoreCreation = ({ isView = false }) => {
  const dispatch = useDispatch();
  const [storeDetails, setStoreDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const navigate = useNavigate();
  const [stateList, setStateList] = useState([]);
  const [reload, setReload] = useState(false);
  useEffect(() => {
    dispatch(stateListAction(onSuccessState, onErrorState));
    dispatch(storeDetailsGetAction("STR0002", onSuccessStore, onErrorStore));
  }, [reload]);
  const onSuccessStore = (data) => {
    setLoading(false);
    setStoreDetails(data?.data);
  };
  const onErrorStore = (data) => {
    setLoading(false);
  };

  const onSuccessState = (data) => {
    setStateList(
      data.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onErrorState = () => { };
  const initialValues = {
    pos_id: storeDetails?.pos_id,
    company: storeDetails?.company,
    company_area: storeDetails?.company_area,
    company_landmark: storeDetails?.company_landmark,
    company_state: storeDetails?.company_state,
    company_city: storeDetails?.company_city,
    company_pincode: storeDetails?.company_pincode,
    company_address: storeDetails?.company_address,
    store_id: storeDetails?.store_id,
    store_code: storeDetails?.store_code,
    cpos_ip_address: storeDetails?.cpos_ip_address,
    cpos_url: storeDetails?.cpos_url,
    company_alias_name: storeDetails?.company_alias_name,
    company_email: storeDetails?.company_email,
    company_telephone1: storeDetails?.company_telephone1,
    company_telephone2: storeDetails?.company_telephone2,
    company_gstn: storeDetails?.company_gstn,
    company_logo: storeDetails?.company_logo || "", // Add company logo here
    store_icon: storeDetails?.store_icon || "", // Add company logo here
    dl_no_20_20b: storeDetails?.dl_no_20_20b || "", // Add company logo here
    dl_no_21_21b: storeDetails?.dl_no_21_21b || "", // Add company logo here
    dl_no_21c: storeDetails?.dl_no_21c || "", // Add company logo here
    dl_no_21f: storeDetails?.dl_no_21f || "", // Add company logo here
    fssai_no: storeDetails?.fssai_no || "", // Add company logo here
    company_remarks: storeDetails?.company_remarks || "", // Add company logo here
    company_return_policy: storeDetails?.company_return_policy || "", // Add company logo here
    company_terms_conditions: storeDetails?.company_terms_conditions || "", // Add company logo here
    pan_number: storeDetails?.pan_number || "",
  };
  const validationSchema = Yup.object().shape({
    pos_id: Yup.string(),
    company_area: Yup.string(),
    company_landmark: Yup.string(),
    company_state: Yup.string(),
    company_city: Yup.string(),
    store_code: Yup.string(),
    cpos_url: Yup.string(),
    cpos_ip_address: Yup.string()
      .matches(
        /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/,
        "Invalid IP address"
      ),
    company_pincode: Yup.string(),
    company_address: Yup.string(),
    company_alias_name: Yup.string(),
    company_email: Yup.string()
      .email("Invalid email format"),
    company_telephone1: Yup.string(),
    company_telephone2: Yup.string(),
    company_gstn: Yup.string()
      .nullable()
      .matches(
        /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})?$/,
        "Invalid GST number"
      ),
    company_logo: Yup.mixed(),
    store_icon: Yup.mixed(),
    fssai_no: Yup.string()
      .matches(/^\d{14}$/, "FSSAI number must be 14 digits"),

    company_remarks: Yup.string()
      .max(500, "Remarks must be at most 500 characters"),

    company_terms_conditions: Yup.string()
      .max(1000, "Terms & Conditions must be at most 1000 characters"),

    company_return_policy: Yup.string()
      .max(1000, "Return Policy must be at most 1000 characters"),

    dl_no_20_20b: Yup.string(),

    dl_no_21_21b: Yup.string(),

    dl_no_21c: Yup.string(),

    dl_no_21f: Yup.string(),
    pan_number: Yup.string()
      .matches(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/, "Invalid PAN number"),
  });

  const onSubmit = (values, { }) => {
    setLoading(true);
    setButtonLoading(true);
    dispatch(
      storeDetailsUpdateAction(
        {
          store_id: "STR0002",
          ...values,
        },
        onSuccess,
        onError
      )
    );
  };

  const onSuccess = (data) => {
    setLoading(false);
    setButtonLoading(false);
    setReload(!reload);
    successToast(formatString(data?.message));
  };
  const onError = (data) => {
    setLoading(false);
    setButtonLoading(false);
  };

  function fetchAddressFn(inputValue, setFieldValue) {
    if (inputValue?.length === 6) {
      dispatch(
        pincodeListAction(
          inputValue,
          (response) => {
            if (response?.[0]?.Status === "Error") {
              return;
            } else {
              const firstPostOffice = response?.[0]?.PostOffice?.[0];
              setFieldValue(`company_state`, firstPostOffice?.State);
              setFieldValue(`company_city`, firstPostOffice?.Block);
            }
          },
          (data) => {
            setFieldValue(`company_state`, "");
            setFieldValue(`company_city`, "");
          }
        )
      );
    } else {
      setFieldValue(`company_state`, "");
      setFieldValue(`company_city`, "");
    }
  }
  return (
    <div className="h-full">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
            values,
            handleSubmit,
            errors,
            setFieldTouched,
            validateForm,
            submitForm,
            setFieldValue,
          }) => {
            console.log(values, "dsfsdfsfsffsdfsdfs");
            console.log(errors, "dsfsdfsfsffsdfsdfs");

            const handleFormSubmit = async () => {
              // Mark all fields as touched to trigger validation
              const fieldsToTouch = [
                "company",
                "company_pincode",
                "company_address",
                "company_alias_name",
                "company_email",
                "company_telephone1",
                "company_telephone2",
                "company_gstn",
                "pan_number",
              ];

              fieldsToTouch.forEach((field) => {
                setFieldTouched(field, true);
              });

              // Validate the form
              const validationErrors = await validateForm();

              // If there are validation errors, show error toast
              if (Object.keys(validationErrors).length > 0) {
                handleShowErrorToast(validationErrors);
                return;
              }

              // If no errors, submit the form
              submitForm();
            };

            return (
              <Form className="flex flex-col justify-between h-full mt-5">
                <div className="px-5">
                  <div className="h-full flex flex-wrap  2xl:gap-[10%] gap-[6%]  w-[100%]  ">
                    <div className="2xl:w-[40%] lg:w-[45%] w-[100%]">
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="text"
                        name="pos_id"
                        placeholder="POS integration Id"
                        label="POS Integration Id"
                        labelWidth="11rem"
                        allowSpecial={true}
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="text"
                        name="cpos_url"
                        id="cpos_url"
                        placeholder="CPOS Url"
                        label="CPOS Url"
                        labelWidth="11rem"
                        allowSpecial={true}
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="text"
                        name="company"
                        placeholder="Company Name"
                        label="Company Name"
                        labelWidth="11rem"
                        allowSpecial={true}
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        allowSpecial={true}
                        // isRequired={true}
                        type="text"
                        name="company_area"
                        placeholder="Area"
                        label="Area"
                        labelWidth="11rem"
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        maxLength={30}
                        type="text"
                        name="company_landmark"
                        placeholder="Landmark"
                        label="Landmark"
                        labelWidth="11rem"
                        allowSpecial={true}
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}

                        type="text"
                        name="company_city"
                        placeholder="City"
                        label="City"
                        labelWidth="11rem"
                        allowSpecial={true}
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-9"
                        // isRequired={true}
                        type="text"
                        name="store_code"
                        placeholder="Pos Code"
                        label="POS Code"
                        labelWidth="11rem"
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="text"
                        name="cpos_ip_address"
                        placeholder="Enter CPOS IP address"
                        label="POS IP address"
                        labelWidth="11rem"
                      />

                      <InputField
                        onKeyDown={() => { }}
                        isDisabled={isView}
                        containerClass="mt-1"
                        type="text"
                        name="dl_no_20_20b"
                        allowSpecial={true}
                        placeholder="e.g., DL No. 20/XYZ/2025"
                        label="DL No. 20/20B"
                        labelWidth="11rem"
                      />

                      <InputField
                        isDisabled={isView}
                        onKeyDown={() => { }}
                        type="text"
                        name="dl_no_21_21b"
                        allowSpecial={true}
                        placeholder="e.g., DL No. 21/ABC/2025"
                        label="DL No. 21/21B"
                        labelWidth="11rem"
                      />

                      <InputField
                        isDisabled={isView}
                        onKeyDown={() => { }}
                        type="text"
                        name="dl_no_21c"
                        allowSpecial={true}
                        placeholder="e.g., DL No. 21C/DEF/2025"
                        label="DL No. 21C"
                        labelWidth="11rem"
                      />
                      <InputField
                        isDisabled={isView}
                        onKeyDown={() => { }}
                        type="text"
                        name="dl_no_21f"
                        allowSpecial={true}
                        placeholder="e.g.,DL No. 21F/GHI/2025"
                        label="DL No. 21F"
                        labelWidth="11rem"
                      />

                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="text"
                        name="company_alias_name"
                        placeholder="Alias Name"
                        label="Alias Name"
                        labelWidth="11rem"
                        allowSpecial={true}
                      />
                      <InputField
                        onKeyDown={() => { }}
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="email"
                        name="company_email"
                        placeholder="email"
                        label="Email"
                        labelWidth="11rem"
                      />
                      <ImageField
                        mainLabel="Store Logo"
                        label="Store Logo W: 80px, H: 50px"
                        // isRequired={true}
                        labelWidth="11rem"
                        name="company_logo"
                      />
                      <ImageField
                        labelClass="pt-5"
                        mainLabel="Store Icon"
                        label="Store Icon W: 64px, H: 64Px"
                        // isRequired={true}
                        labelWidth="11rem"
                        name="store_icon"
                      />
                    </div>

                    <div className="2xl:w-[40%] lg:w-[45%] w-[100%]">
                      <InputField
                        isDisabled={isView}
                        // isRequired={true}
                        type="text"
                        name="pan_number"
                        placeholder="xxxxxxxxxxx"
                        label="PAN Number"
                        labelWidth="11rem"
                      />
                      <InputField
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="text"
                        name="fssai_no"
                        placeholder="e.g., 10017022012345"
                        label="Fssai No."
                        labelWidth="11rem"
                      />
                      <InputField
                        // isRequired={true}
                        type="text"
                        name="company_gstn"
                        placeholder="xxxxxxxxxxxxxxx"
                        label="GSTIN"
                        labelWidth="11rem"
                      />
                      <SelectField
                        // isDisabled={true}
                        placeholder={"Select state"}
                        options={stateList}
                        label={"State"}
                        id={"company_state"}
                        name="company_state"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        // isRequired={true}
                        labelWidth="11rem"
                      />
                      <InputField
                        maxLength={6}
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        // type="text"
                        type="number"
                        name="company_pincode"
                        placeholder="Enter Pincode"
                        label="Pincode"
                        labelWidth="11rem"
                        handleChange={(e) => {
                          fetchAddressFn(e?.target?.value, setFieldValue);
                        }}
                      />
                      <TextAreaField
                        label="Address"
                        placeholder="Address"
                        name="company_address"
                        id={"company_address"}
                        // isRequired={true}
                        labelWidth="11rem"
                        feildHeight="6rem"
                        allowSpecial={true}
                      />
                      <InputField
                        maxLength={10}
                        isDisabled={isView}
                        containerClass="mt-10"
                        // isRequired={true}
                        type="number"
                        name="company_telephone1"
                        placeholder="000-000-000"
                        label="Telephone 1"
                        labelWidth="11rem"
                      />
                      <InputField
                        maxLength={10}
                        isDisabled={isView}
                        containerClass="mt-1"
                        // isRequired={true}
                        type="number"
                        name="company_telephone2"
                        placeholder="000-000-000"
                        label="Telephone 2"
                        labelWidth="11rem"
                      />

                      <TextAreaField
                        containerClass="mt-1"
                        label="Remarks"
                        placeholder="Remarks"
                        name="company_remarks"
                        id={"company_remarks"}
                        // isRequired={true}
                        labelWidth="11rem"
                        feildHeight="6rem"
                        allowSpecial={true}
                      />
                      <TextAreaField
                        containerClass="mt-1"
                        label="Terms & Conditions"
                        placeholder="Invoice Terms & Conditions"
                        name="company_terms_conditions"
                        id={"company_terms_conditions"}
                        // isRequired={true}
                        labelWidth="11rem"
                        feildHeight="10rem"
                        allowSpecial={true}
                      />
                      <TextAreaField
                        containerClass="mt-1"
                        label="Return Policy"
                        placeholder="Invoice Return Policy"
                        name="company_return_policy"
                        id={"company_return_policy"}
                        // isRequired={true}
                        labelWidth="11rem"
                        feildHeight="10rem"
                        allowSpecial={true}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-between px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <DraftButton onclkFn={() => navigate(-1)} text="Cancel" />
                  <AddButton
                    loading={buttonLoading}
                    onclkFn={handleFormSubmit}
                    prefixIcon={false}
                    text="Save"
                    type="submit"
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      )}
    </div>
  );
};

export default StoreCreation;
